/**
 * Spanish (es) mappings for MessageLimitModal
 */

export const messageLimitModalES = {
  // Header
  "Long Conversation": "Conversación Larga",
  "messages in this chat": "mensajes en este chat",

  // Main message
  "This conversation has grown quite long! For better performance and organization, we recommend starting a new chat.": "¡Esta conversación se ha vuelto bastante larga! Para un mejor rendimiento y organización, recomendamos iniciar un nuevo chat.",

  // Benefits section
  "Benefits of starting fresh:": "Beneficios de empezar de nuevo:",
  "Faster response times": "Tiempos de respuesta más rápidos",
  "Better conversation focus": "Mejor enfoque en la conversación",
  "Easier to find specific topics": "Más fácil encontrar temas específicos",

  // Buttons
  "Continue Here": "Continuar Aquí",
  "Start New Chat": "Iniciar Nuevo Chat",

  // Footer
  "You can always return to this conversation later": "Siempre puedes regresar a esta conversación más tarde"
};
